function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import i18next from "i18next";
import loadJson from "./loadJson";
const DEFAULT_URL = "serverconfig/";

/**
 * Provides information about the configuration of the Terria server, by querying /serverconfig
 */
class ServerConfig {
  constructor() {
    /**
     * Contains configuration information retrieved from the server. The attributes are defined by TerriaJS-Server but include:
     *   version: current version of server
     *   proxyAllDomains: whether all domains can be proxied
     *   allowProxyFrom: array of domains that can be proxied
     *   maxConversionSize: maximum size, in bytes, of files that can be uploaded to conversion service
     *   newShareUrlPrefix: if defined, the share URL service is active
     *   shareUrlPrefixes: object defining share URL prefixes that can be resolved
     *   additionalFeedbackParameters: array of additional feedback parameters that can be used
     */
    _defineProperty(this, "config", void 0);
    _defineProperty(this, "serverConfigUrl", void 0);
  }
  /**
   * Initialises the object by fetching the configuration from the server. Note
   * that if the request to get config from the proxy server fails, an error is
   * logged and nothing else happens.
   *
   * @param  serverConfigUrl Optional override URL.
   * @return Promise that resolves to the configuration object itself.
   */
  async init(serverConfigUrl) {
    if (this.config !== undefined) {
      return Promise.resolve(this.config);
    }
    this.serverConfigUrl = serverConfigUrl !== null && serverConfigUrl !== void 0 ? serverConfigUrl : DEFAULT_URL;
    try {
      this.config = await loadJson(this.serverConfigUrl);
      return this.config;
    } catch (_unused) {
      console.error(i18next.t("core.serverConfig.failedToGet", {
        serverConfigUrl: this.serverConfigUrl
      }));
    }
  }
}
export default ServerConfig;